import { useTranslate } from '@tolgee/react'
import { TomAutoComplete, TomAutoCompleteProps } from '@tom-ui/ui'
import { DATE_RANGE_OPTIONS, DateRangeEnum } from '@yard/constants/dateRanges'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'

type Props<M extends boolean = false> = {
  onChange: (value: M extends true ? DateRangeEnum[] : DateRangeEnum) => void
} & TomAutoCompleteProps<DateRangeEnum, M>

export const DateRangeAutoComplete = observer(<M extends boolean = false>(props: Props<M>) => {
  const { t } = useTranslate()
  const { dataCy, defaultValue, label, onChange } = props

  const [options] = useState<DateRangeEnum[]>(
    DATE_RANGE_OPTIONS.map<DateRangeEnum>(option => option.key),
  )

  return (
    <TomAutoComplete
      {...props}
      dataCy={dataCy ?? 'date-range-autocomplete'}
      label={label ?? t('dateRange', 'Date Range')}
      options={options}
      defaultValue={defaultValue}
      enablePortal
      placeholder={t('selectDateRange', 'Select date range')}
      onChangeEntity={entity => {
        onChange(entity as M extends true ? DateRangeEnum[] : DateRangeEnum)
      }}
    />
  )
})
